// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Typography } from '../../../lib/base';

const START_YEAR = '2022';
export function Copyright(): React.ReactElement {
  const currYear = new Date().toLocaleString('en-US', { timeZone: 'Pacific/Kiritimati', year: 'numeric' });

  return (
    <Typography variant="caption">
      Copyright © {START_YEAR}
      {currYear === START_YEAR ? '' : `-${currYear}`} Microgreen Manager LLC. All rights reserved.
    </Typography>
  );
}
